import throttle from 'just-throttle';
import './back-to-top';
import { hideSearchForm } from './search-toggle';
const desktopToggleButtons = document.querySelectorAll('.main-navigation .sub-menu-toggle');
const mobileToggleButtons = document.querySelectorAll('.mobile-navigation .sub-menu-toggle');
const mainNav = document.querySelector('.main-navigation');
for (const subMenu of document.querySelectorAll('ul.sub-menu')) {
    subMenu.role = 'list';
}
for (const submenuToggle of [...desktopToggleButtons, ...mobileToggleButtons]) {
    submenuToggle.addEventListener('click', (event) => {
        event.preventDefault();
        hideSearchForm();
        closeAllSubMenus(submenuToggle);
        const isOpen = submenuToggle.ariaExpanded === 'true';
        isOpen ? closeSubMenu(submenuToggle) : openSubMenu(submenuToggle);
    });
}
function openSubMenu(toggleButton) {
    const parent = toggleButton.closest(`#menu-item-${toggleButton.dataset.parent}`);
    parent === null || parent === void 0 ? void 0 : parent.classList.add('show-sub-menu');
    toggleButton.ariaExpanded = 'true';
}
function closeSubMenu(toggleButton) {
    const parent = toggleButton.closest(`#menu-item-${toggleButton.dataset.parent}`);
    parent === null || parent === void 0 ? void 0 : parent.classList.remove('show-sub-menu');
    toggleButton.ariaExpanded = 'false';
}
export function closeAllSubMenus(exception) {
    for (const submenuToggle of desktopToggleButtons) {
        if (submenuToggle === exception) {
            continue;
        }
        closeSubMenu(submenuToggle);
    }
}
// Close all on resize
const throttledCloseAllSubMenus = throttle(closeAllSubMenus, 1000);
window.addEventListener('resize', () => throttledCloseAllSubMenus());
// Close all on outside click
document.addEventListener('click', (event) => {
    if (!(mainNav === null || mainNav === void 0 ? void 0 : mainNav.contains(event.target))) {
        closeAllSubMenus();
    }
});
const mobileMenuToggle = document.querySelector('.mobile-navigation__toggle');
mobileMenuToggle === null || mobileMenuToggle === void 0 ? void 0 : mobileMenuToggle.addEventListener('click', () => {
    const isOpen = mobileMenuToggle.ariaExpanded === 'true';
    isOpen ? closeMobileMenu() : openMobileMenu();
});
function openMobileMenu() {
    if (!mobileMenuToggle) {
        return;
    }
    mobileMenuToggle.classList.add('is-active');
    mobileMenuToggle.ariaExpanded = 'true';
}
function closeMobileMenu() {
    if (!mobileMenuToggle) {
        return;
    }
    mobileMenuToggle.classList.remove('is-active');
    mobileMenuToggle.ariaExpanded = 'false';
}
